import React from 'react'

import { ICheckboxProps } from './types'

export const Checkbox: React.FC<ICheckboxProps> = ({ label, ...rest }) => {
  return (
    <label>
      <input {...rest} type="checkbox" />
      {!!label && <span className="checkbox-label">{label}</span>}
    </label>
  )
}

export default Checkbox
